module.exports = __webpack_public_path__ + "img/011.86e16b9e.png";